




































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  DrivewealthAccountManagementType, InvestmentFeeSchedule, InvestmentManagementType
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import InvestmentAccountTypeFeeDetails from "@/shared/components/investments/drivewealth/InvestmentAccountTypeFeeDetails.vue";
import InvestmentFeeDisclaimer from "@/employee/components/investments/drivewealth/InvestmentFeeDisclaimer.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useEnrollmentStore } from "@/employee/store/enrollment";

@Component({
  components: {
    GenericLoadingSpinner,
    DrivewealthNavigation,
    InvestmentAccountTypeFeeDetails,
    InvestmentFeeDisclaimer,
    AccountTypeSubheader
  }
})
export default class DrivewealthFees extends Vue {
  @Prop() accountId: number;

  drivewealthStore = useDrivewealthStore();
  custodianSettingsStore = useCustodianSettingsStore();
  enrollmentStore = useEnrollmentStore();

  formatCurrency = formatCurrency;

  mounted (): void {
    this.enrollmentStore.loadFees();
  }

  get investmentFees (): InvestmentFeeSchedule[] {
    const feeSchedule = this.enrollmentStore.feeSchedule;

    if (!feeSchedule.investmentFees.length) {
      return [];
    }

    return feeSchedule.investmentFees;
  }

  convertedAccountType (internalAccountType: string): DrivewealthAccountManagementType {
    switch (internalAccountType) {
      case InvestmentManagementType.Managed: {
        return DrivewealthAccountManagementType.RiaManaged;
      }
      case InvestmentManagementType.Advisory: {
        return DrivewealthAccountManagementType.Advisory;
      }
      case InvestmentManagementType.SelfDirected: {
        return DrivewealthAccountManagementType.OpenBrokerage;
      }
    }
  }

  iconType (accountManagementType: DrivewealthAccountManagementType): string {
    switch (accountManagementType) {
      case DrivewealthAccountManagementType.Advisory:
        return "fa-solid fa-sliders";
      case DrivewealthAccountManagementType.OpenBrokerage:
        return "fa-solid fa-list-check";
      case DrivewealthAccountManagementType.RiaManaged:
        return "fa-solid fa-handshake";
      default:
        return "fa-solid fa-sliders";
    }
  }
}
